import { render, staticRenderFns } from "./ListObjectFeatures.vue?vue&type=template&id=3bb6c5e6"
import script from "./ListObjectFeatures.vue?vue&type=script&lang=js"
export * from "./ListObjectFeatures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports